import FeatureLandingPage from '@/components/feature-landing-page/FeatureLandingPage';
import { SwatchIcon } from '@heroicons/react/24/outline';
import {
  DocumentDuplicateIcon,
  BoltIcon,
  CheckBadgeIcon,
  ChartBarIcon,
  ClipboardDocumentCheckIcon,
  ClockIcon
} from '@heroicons/react/24/solid';
import heroImage from '@/public/spaced-repetition-hero2.png';
import overviewImage from '@/public/spaced-repetition-overview.png';
import tutorialImage from '@/public/spaced-repetition-tutorial.png';

const overviewSection = {
  miniText: 'Memorize Efficiently',
  title: 'Spaced Repetition for optimal learning',
  image: overviewImage,
  description:
    'Enhance your memorization using our spaced repetition feature. Choose your deck, review flashcards efficiently, and track your progress.',
  features: [
    {
      name: 'Select any deck.',
      description:
        'Choose any deck you want to memorize and start studying flashcards with spaced repetition.',
      icon: DocumentDuplicateIcon
    },
    {
      name: 'Custom review options.',
      description:
        'Rate the recall difficulty for every flashcard with options such as easy, good, hard, or again.',
      icon: CheckBadgeIcon
    },
    {
      name: 'Automated tracking.',
      description:
        'Limbiks will automatically keep track of your reviews and remind you when they are due.',
      icon: BoltIcon
    },
    {
      name: 'Visual progress tracker.',
      description:
        'See the status of your reviews and know when you have fully memorized your flashcards with our custom tracker.',
      icon: ChartBarIcon
    },
    {
      name: 'Memorization forecast.',
      description:
        'After fully memorizing, you will see when your cards are due for review again.',
      icon: ClockIcon
    },
    {
      name: 'Question rephrasing.',
      description:
        'Automatically re-word flashcards to ensure you memorize the concepts, not the flashcards.',
      icon: SwatchIcon
    }
  ]
};

const tutorialSection = {
  miniText: 'Get Started',
  title: 'How It Works',
  image: tutorialImage,
  description:
    'Select a deck and let spaced repetition takes the guess work out of how you should be studying your flashcards.',
  features: [
    {
      name: 'Select a deck.',
      description:
        'Choose the deck of flashcards you want to start memorizing.',
      icon: DocumentDuplicateIcon
    },
    {
      name: 'Rate your recall.',
      description:
        'For each flashcard, select whether the answer was easy, good, hard, or if you need to review it again.',
      icon: ClipboardDocumentCheckIcon
    },
    {
      name: 'Track your progress.',
      description:
        'Monitor your memorization progress with our custom tracker and see when cards are due for review.',
      icon: ChartBarIcon
    }
  ]
};

export default function _PdfToFlashcards() {
  return (
    <FeatureLandingPage
      heroImage={heroImage}
      analyticsName="home_spaced"
      overviewSection={overviewSection}
      tutorialSection={tutorialSection}
      heroMiniTitle="Spaced Repetition"
      heroTitle="Memorize with spaced repetition"
      heroImageUrl="/spaced-repetition-hero2.png"
      heroDescription="Select any deck you want to memorize and start studying flashcards with spaced repetition. Rate your recall, and let Limbiks track your reviews and remind you when they are due to maximize your learning efficiency."
    />
  );
}
